import Vue from 'vue';
import Router from 'vue-router';
import home from '@/view/home'; // 首页
import index from '@/view/index'; // 主页
import partner from '@/view/partner'; // 合作伙伴
import problem from '@/view/problem'; // 问题提交
import user from '@/view/user';
import merchant from '@/view/merchant';
import profit from '@/view/profit';
import payment from '@/view/payment';
import login from '@/view/login';
import wxOption from '@/view/wxOption.vue'
import smFace from '@/view/smFace';
import smAi from '@/view/smAi.vue'
import msgAdmin from '@/view/msgAdmin.vue'
import codeManger from '@/view/codeManger.vue'
import snCode from '@/view/snCode.vue'
import smShopOrder from '@/view/smShopOrder.vue'
import takeaway from '@/view/takeaway.vue'
import douyinMch from '@/view/douyinMch.vue'
import orgFrMx from '@/view/orgFrMx.vue'
import cyAdmin from '@/view/cyAdmin.vue'

Vue.use(Router)

let router = new Router({
  routes: [{
      path: '/',
      name: 'index',
      redirect: '/login',
      component: index,
      meta: {
        isLogin: true // 添加该字段，表示进入这个路由是需要登录的
      }, //路由元
      children: [{
          path: '/home', //系统首页
          component: home,
          meta: {
            isLogin: true
          },
        }, {
          path: '/user', //员工档案
          component: user,
          meta: {
            isLogin: true
          },
        }, {
          path: '/merchant', //商户管理
          component: merchant,
          meta: {
            isLogin: true
          },
        }, {
          path: '/partner', //下级代理
          component: partner,
          meta: {
            isLogin: true
          },
        }, {
          path: '/problem', //问题提交
          component: problem,
          meta: {
            isLogin: true
          },
        }, {
          path: '/profit', //支付分润
          component: profit,
          meta: {
            isLogin: true
          },
        }, {
          path: '/payment', //支付进件
          component: payment,
          meta: {
            isLogin: true
          },
        },
        {
          path: '/wxOption', //微信设置
          component: wxOption,
          meta: {
            isLogin: true
          },
        },
        {
          path: '/smFace', //人脸识别
          component: smFace,
          meta: {
            isLogin: true
          },
        },
        {
          path: '/smAi', //ai识别
          component: smAi,
          meta: {
            isLogin: true
          },
        },
        {
          path: '/msgAdmin', //ai识别
          component: msgAdmin,
          meta: {
            isLogin: true
          },
        },
        {
          path: '/codeManger', //PRO_CODE_MANGER
          component: codeManger,
          meta: {
            isLogin: true
          },
        }, {
          path: '/snCode', //
          component: snCode,
          meta: {
            isLogin: true
          },
        }, {
          path: '/smShopOrder', //
          component: smShopOrder,
          meta: {
            isLogin: true
          },
        }, {
          path: '/takeaway', //
          component: takeaway,
          meta: {
            isLogin: true
          },
        }, {
          path: '/douyinMch', //
          component: douyinMch,
          meta: {
            isLogin: true
          },
        }, {
          path: '/orgFrMx', //
          component: orgFrMx,
          meta: {
            isLogin: true
          },
        }, {
          path: '/cyAdmin', //
          component: cyAdmin,
          meta: {
            isLogin: true
          },
        },

      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login
    }
  ]
})
// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.isLogin)) { //判断是否需要登录
    if (!localStorage.getItem('bykPlatform')) {
      next({
        path: "/login",
      });
      return
    }
    let {
      partnerInfo
    } = JSON.parse(localStorage.getItem('bykPlatform'))
    // console.log(JSON.parse(localStorage.getItem('bykPlatform')))
    if (partnerInfo.phone) {
      next();
    } else {
      next({
        path: "/login",
      });
    }
  } else {
    next()
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js